module.exports = __webpack_public_path__ + "img/iconuser1.e5158d94.png";